import React from "react";
import ChildrenForm from "./ChildrenForm";

interface FamilyProps {
  nationality: any;
  identificationTypes: any;
  maritalStatus: any;
  form: any;
  parentForm: any;
}

const FamilyData = ({ nationality, identificationTypes, maritalStatus, form, parentForm }: FamilyProps) => {
  return (
    <div className='takaful--recipient-container'>
      <ChildrenForm
        form={form}
        parentForm={parentForm}
        nationality={nationality}
        identificationTypes={identificationTypes}
        maritalStatus={maritalStatus}
      />
    </div>
  );
};

export default FamilyData;
